import { Breakpoint } from "@mui/material/styles";
import { TResponsivePx } from "src/types/responsive";

interface IResolveResponsivePxParams {
    valuesPx: TResponsivePx;
    breakpoints: readonly Breakpoint[];
}

export const resolveResponsivePx = ({ valuesPx, breakpoints }: IResolveResponsivePxParams) =>
    breakpoints.reduce<Partial<Record<Breakpoint, number>>>(
        (resolvedPx, breakpoint, index) => ({
            ...resolvedPx,
            [breakpoint]: valuesPx[breakpoint] ?? (index === 0 ? valuesPx.xs : resolvedPx[breakpoints[index - 1]]),
        }),
        {}
    ) as Record<Breakpoint, number>;

interface ISumResponsivePxParams {
    summandsPx: readonly TResponsivePx[];
    breakpoints: readonly Breakpoint[];
}

export const sumResponsivePx = ({ summandsPx, breakpoints }: ISumResponsivePxParams): TResponsivePx => {
    const resolvedSummandsPx = summandsPx.map(valuesPx => resolveResponsivePx({ valuesPx, breakpoints }));

    return breakpoints.reduce<TResponsivePx>(
        (sumPx, breakpoint) => ({ ...sumPx, [breakpoint]: resolvedSummandsPx.reduce((total, resolvedPx) => total + resolvedPx[breakpoint], 0) }),
        { xs: 0 }
    );
};
